import React from 'react';
import PropTypes from 'prop-types';
import NBAInsightEntity from '../../entities/nba/NBAInsightEntity';
import NBABL from './NBABL';

class HeroCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleAction = this.handleAction.bind(this);
    this.state = this.getState();
  }
  getState() {
    return { viewData: this.props.data[0] };
  }
  handleAction(e) {
    e.preventDefault();
    this.props.action(this.state.viewData);
  }
  render() {
    const image = NBABL.getCompletePath(this.state.viewData.imageUrl);
    const htmldata = NBABL.readResourceContent(
      this.state.viewData.textStaticUrl
    );
    if (image && htmldata) {
      return (
        <div className="l-tile l-tile--large c-hero">
          <div className="c-hero__body">
            <div className="c-hero__inner">
              <h3 className="c-hero__title">{htmldata.textHeader}</h3>
              <p className="c-hero__text">{htmldata.textSubHeader}</p>
              {htmldata.textValueParts.map((part, index) =>
                index < 3 ? (
                  <p
                    className="c-hero__text"
                    key={`htmldata.textValueParts_${index}`}
                  >
                    {part}
                  </p>
                ) : null
              )}
              {this.state.viewData.isAction && (
                <div className="c-hero__button">
                  <a
                    aria-haspopup="true"
                    className="c-hero__link"
                    href="javascript:;"
                    onClick={this.handleAction}
                  >
                    {NBABL.getButtonText(htmldata)}
                  </a>
                </div>
              )}
              <p className="c-hero__terms">
                <small>{htmldata.textTnC}</small>
              </p>
            </div>
          </div>
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="c-hero__media"
          />
        </div>
      );
    } else {
      return null;
    }
  }
}
HeroCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(NBAInsightEntity)).isRequired,
  action: PropTypes.func,
  type: PropTypes.string,
};
export default HeroCard;
